import React, { memo } from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import { Form, Formik } from 'formik'

import { CerealesSelect } from '../../cerealesSelect/CerealesSelect'
import { CerealesVariedadesSelect } from '../../cerealesVariedadesSelect/CerealesVariedadesSelect'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import { LLENADO_SCHEMA } from '../../constants'
import { EtiquetasSelect } from '../../etiquetasSelect/EtiquetasSelect'

export const OperacionInicioDeLlenadoView = memo(({ silo: { nombreCorto }, cancelar, aceptar }) => (
  <Formik
    initialValues={{
      cereal: '',
      variedad: '',
      etiqueta: '',
      color: ''
    }}
    onSubmit={aceptar}
    validationSchema={LLENADO_SCHEMA}
  >
    {({ isSubmitting, isValid }) => (
      <Form>
        <Grid container spacing={2} direction='column' justify='space-around'>
          <Grid item>
            <Typography variant='h4'>Inicio de llenado de {nombreCorto}</Typography>
          </Grid>
          <Grid container spacing={2} item>
            <Grid item xs={12} sm={6}>
              <CerealesSelect />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CerealesVariedadesSelect />
            </Grid>
          </Grid>
          <Grid item>
            <EtiquetasSelect />
          </Grid>
          <Grid container item spacing={2} justify='space-between'>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='secondary'
                disabled={isSubmitting}
                startIcon={<HighlightOffIcon />}
                onClick={cancelar}>
                Cancelar
              </Button>
            </Grid>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='primary'
                disabled={isSubmitting || !isValid}
                startIcon={<CheckCircleOutlineIcon />}
                type='submit'>
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    )}
  </Formik>
))
